
import { Component, Vue } from 'vue-property-decorator'
import Presentation from "@/views/Settings/Presentation.vue"
import Account from "@/views/Settings/Account.vue"

@Component({
  components: {
    Presentation,
    Account
  }
})
export default class Settings extends Vue {
  private tab = null
  private items = [
    { tab: 'settings.presentation.title', component: Presentation },
    { tab: 'settings.accountLabel', component: Account }
  ]
}
